import type React from "react";
import type {MainComponentBaseProps} from "../RootTypes.ts";
import {HeaderAlert} from "../alerts/HeaderAlert.tsx";
import {DevopsMenu} from "../devops/DevopsMenu.tsx";
import {SelectDataset} from "./SelectDataset.tsx";
import {SingleDropdownMenu} from "../../../pages/default-menus/SingleDropdownMenu.tsx";

export const MainHeader: React.FC<MainComponentBaseProps> = () => {
    return <>
        <HeaderAlert/>
        <SelectDataset/>
        <div style={{flexGrow: 1}}/>
        <SingleDropdownMenu/>
        <DevopsMenu/>
    </>
}

